import { MapPin, Phone, Mail, Clock, Facebook, Instagram } from "lucide-react";

export default function Contact() {
  return (
    <div className="min-h-screen bg-[#FAF9F6]" data-testid="contact-page">
      <section className="bg-[#050505] text-[#FAF9F6] py-14">
        <div className="max-w-6xl mx-auto px-4 lg:px-8">
          <h1 className="font-heading text-5xl text-[#D4AF37]">Contact <span className="italic text-[#FAF9F6]">Us</span></h1>
          <p className="text-[#FAF9F6]/60 max-w-xl mt-2">Questions, catering inquiries, lechon reservations — we're a phone call away.</p>
        </div>
      </section>
      <div className="max-w-6xl mx-auto px-4 lg:px-8 py-14 grid md:grid-cols-2 gap-10">
        <div className="space-y-4">
          <div className="mart-card p-6">
            <MapPin className="w-7 h-7 text-[#D4AF37] mb-2"/>
            <div className="font-heading text-xl text-[#1A2421]">Visit us</div>
            <p className="text-[#5C6B64]">44164 10th St W<br/>Lancaster, CA 93534</p>
          </div>
          <div className="mart-card p-6 grid grid-cols-2 gap-4">
            <div>
              <Phone className="w-6 h-6 text-[#D4AF37] mb-2"/>
              <div className="font-accent text-[10px] text-[#2C4A3B]">RESTAURANT</div>
              <div className="font-heading text-lg">661-206-7487</div>
            </div>
            <div>
              <Phone className="w-6 h-6 text-[#D4AF37] mb-2"/>
              <div className="font-accent text-[10px] text-[#2C4A3B]">SEAFOOD MART</div>
              <div className="font-heading text-lg">661-206-8619</div>
            </div>
          </div>
          <div className="mart-card p-6">
            <Mail className="w-6 h-6 text-[#D4AF37] mb-2"/>
            <a href="mailto:msmac0428@gmail.com" className="font-heading text-lg text-[#2C4A3B]">msmac0428@gmail.com</a>
          </div>
          <div className="mart-card p-6">
            <Clock className="w-6 h-6 text-[#D4AF37] mb-2"/>
            <div className="font-accent text-[10px] text-[#2C4A3B]">HOURS</div>
            <ul className="text-sm text-[#1A2421] mt-1 space-y-1">
              <li><strong>Restaurant</strong> · Mon–Sun 10:30am–7:00pm</li>
              <li><strong>Mart</strong> · Mon–Sat 9:30am–6:30pm · Sun 9:00am–5:30pm</li>
            </ul>
          </div>
          <div className="flex gap-3">
            <a href="#" className="w-11 h-11 rounded-full bg-[#2C4A3B] text-[#FAF9F6] flex items-center justify-center"><Facebook className="w-5 h-5"/></a>
            <a href="#" className="w-11 h-11 rounded-full bg-[#2C4A3B] text-[#FAF9F6] flex items-center justify-center"><Instagram className="w-5 h-5"/></a>
          </div>
        </div>
        <div className="mart-card aspect-square lg:aspect-auto overflow-hidden">
          <iframe
            title="Maharlika Map"
            src="https://www.google.com/maps?q=44164+10th+St+W,+Lancaster,+CA+93534&output=embed"
            className="w-full h-full min-h-[400px] border-0"
          />
        </div>
      </div>
    </div>
  );
}
